export default __webpack_public_path__ + "static/media/banner2.f12e30d6.png";